import React from 'react'
import type { DashboardPageName } from '../types'

const ICONS: Record<string, React.ReactNode> = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  contacts: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  lapsed: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  engaging: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  recovered: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  messages: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  offerings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  reports: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  business: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.07 4.93l-1.41 1.41M5.34 18.66l-1.41 1.41M20 12h-2M6 12H4M19.07 19.07l-1.41-1.41M5.34 5.34L3.93 3.93" />
      <path d="M12 2v2M12 20v2" />
    </svg>
  ),
  adminQueue: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  adminBiz: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
      <line x1="12" y1="12" x2="12" y2="16" /><line x1="10" y1="14" x2="14" y2="14" />
    </svg>
  ),
  adminAi: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M12 2a3 3 0 0 1 3 3v3" /><path d="M9 8V5a3 3 0 0 1 3-3" />
      <rect x="4" y="8" width="16" height="12" rx="3" /><circle cx="9" cy="14" r="1" /><circle cx="15" cy="14" r="1" />
    </svg>
  ),
  adminSlots: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  adminBilling: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  adminUsers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="w-[15px] h-[15px]">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
}

function NavSectionLabel({ label, first = false }: { label: string; first?: boolean }) {
  return (
    <div
      className={[
        'px-3 pb-1.5 text-[10px] font-mono tracking-[0.12em] uppercase text-white/35',
        first ? 'pt-1' : 'pt-4 mt-3 border-t border-white/[0.06]',
      ].join(' ')}
    >
      {label}
    </div>
  )
}

function NavItem({
  active,
  onClick,
  icon,
  label,
  badge,
}: {
  active: boolean
  onClick: () => void
  icon: React.ReactNode
  label: string
  badge?: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'relative w-full flex items-center gap-3 px-3.5 py-2.5 rounded-[9px] text-[14px] text-left select-none transition-all duration-150',
        active
          ? 'bg-[#e05a2b]/15 text-[#e05a2b] font-semibold'
          : 'bg-transparent text-gray-400 hover:text-gray-100 hover:bg-white/[0.04]',
      ].join(' ')}
    >
      {active && <span className="absolute left-0 top-1/2 -translate-y-1/2 w-[3px] h-[18px] rounded-full bg-[#e05a2b]" />}
      <span className="w-[17px] h-[17px] shrink-0 flex items-center justify-center [&>svg]:w-[17px] [&>svg]:h-[17px]">{icon}</span>
      <span className="flex-1 leading-none">{label}</span>
      {badge}
    </button>
  )
}

export function Sidebar({
  activePage,
  onSelectPage,
  onSignOut,
  user,
  businessName,
  businessLogoUrl,
  contactsCount,
  lapsedCount,
  engagingCount,
  recoveredCount,
  messagesNotifCount,
  isAdmin,
  planDisplayName,
  subscriptionStatus,
  cancelAtPeriodEnd,
}: {
  activePage: DashboardPageName
  onSelectPage: (page: DashboardPageName) => void
  onSignOut: () => void
  user?: {
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    avatarUrl?: string | null
  }
  businessName?: string | null
  businessLogoUrl?: string | null
  contactsCount?: number | null
  lapsedCount?: number | null
  engagingCount?: number | null
  recoveredCount?: number | null
  messagesNotifCount?: number | null
  isAdmin?: boolean
  planDisplayName?: string | null
  subscriptionStatus?: string | null
  cancelAtPeriodEnd?: boolean
}) {
  const rawName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim()
  const hasName = rawName.length > 0
  const displayName = hasName ? rawName : null
  const initials = hasName
    ? rawName
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(w => w[0]?.toUpperCase())
        .join('')
        .slice(0, 2)
    : null
  const email = user?.email ?? null
  const avatarUrl = user?.avatarUrl ?? null
  const [menuOpen, setMenuOpen] = React.useState(false)
  const menuRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!menuOpen) return
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuOpen])

  const planLabel = planDisplayName != null
    ? [
        planDisplayName,
        cancelAtPeriodEnd && subscriptionStatus === 'ACTIVE' ? '· Canceling' : null,
        subscriptionStatus === 'TRIALING' ? '· Trial' : null,
        subscriptionStatus === 'PAST_DUE' ? '· Past due' : null,
        subscriptionStatus === 'GRACE' ? '· Grace' : null,
        subscriptionStatus === 'CANCELED' ? '· Canceled' : null,
      ].filter(Boolean).join(' ')
    : null

  const redBadge = (n: number) => (
    <span className="ml-auto bg-red-500 text-white text-[10px] font-semibold font-mono w-[18px] h-[18px] rounded-full flex items-center justify-center shrink-0">
      {n}
    </span>
  )

  const tealBadge = (n: number) => (
    <span className="ml-auto bg-teal-600 text-white text-[10px] font-semibold font-mono min-w-[20px] h-[18px] px-1 rounded-full flex items-center justify-center shrink-0">
      {n > 99 ? '99+' : n}
    </span>
  )

  const grayCount = (n: number) => (
    <span className="ml-auto text-[11px] font-mono text-white/40 shrink-0">{n}</span>
  )

  const item = (page: DashboardPageName, iconKey: string, label: string, badge?: React.ReactNode) => (
    <NavItem
      key={page}
      active={activePage === page}
      onClick={() => onSelectPage(page)}
      icon={ICONS[iconKey]}
      label={label}
      badge={badge}
    />
  )

  return (
    <aside className="w-[220px] shrink-0 bg-[#0e0e0e] border-r border-white/[0.08] flex flex-col fixed top-0 left-0 bottom-0 z-10">
      {/* Business identity header */}
      <div
        className="px-[18px] py-4 flex items-center gap-3 border-b border-white/[0.08] relative"
        title={businessName ?? undefined}
      >
        {/* Subtle warm glow behind the header */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -top-6 -left-4 w-32 h-20 rounded-full opacity-40 blur-2xl"
          style={{ background: 'radial-gradient(closest-side, rgba(224,90,43,0.35), transparent)' }}
        />

        {/* Avatar — business logo when set, otherwise gradient initial */}
        <div className="relative shrink-0">
          {!isAdmin && businessLogoUrl ? (
            <div
              className="relative w-9 h-9 rounded-[10px] overflow-hidden ring-1 ring-white/15 shadow-[0_4px_12px_rgba(224,90,43,0.18)] bg-white"
            >
              <img
                src={businessLogoUrl}
                alt={businessName ?? 'Business logo'}
                className="absolute inset-0 w-full h-full object-cover"
                draggable={false}
              />
              {/* Inner highlight for tactile feel */}
              <span
                aria-hidden="true"
                className="absolute inset-0 pointer-events-none"
                style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.10), transparent 55%)' }}
              />
            </div>
          ) : (
            <div
              className={[
                'relative w-9 h-9 rounded-[10px] flex items-center justify-center text-[15px] font-bold text-white select-none ring-1 ring-white/10',
                isAdmin
                  ? 'bg-gradient-to-br from-neutral-700 to-neutral-900 shadow-[0_4px_10px_rgba(0,0,0,0.45)]'
                  : 'bg-gradient-to-br from-[#f0703f] to-[#c44a1e] shadow-[0_4px_12px_rgba(224,90,43,0.35)]',
              ].join(' ')}
              style={{ fontFamily: "'Manrope', sans-serif", letterSpacing: '-0.02em' }}
            >
              {isAdmin ? 'N' : (businessName && businessName.length > 0 ? businessName.charAt(0).toUpperCase() : '')}
              {/* Inner highlight for tactile feel */}
              <span
                aria-hidden="true"
                className="absolute inset-0 rounded-[10px] pointer-events-none"
                style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.18), transparent 55%)' }}
              />
            </div>
          )}
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-1">
          {isAdmin ? (
            <div className="text-[14px] font-semibold text-gray-100 truncate tracking-tight">Nudge</div>
          ) : (
            <>
              {businessName ? (
                <div className="text-[14px] font-semibold text-gray-100 truncate leading-tight tracking-tight">
                  {businessName}
                </div>
              ) : (
                <div className="h-3.5 w-28 bg-white/10 rounded animate-pulse" />
              )}
              {planLabel && (
                <span className="inline-flex items-center gap-1.5 text-[9.5px] font-mono font-semibold px-1.5 py-0.5 rounded-md bg-gradient-to-r from-[#e05a2b]/20 to-[#e05a2b]/8 text-[#ffae8c] border border-[#e05a2b]/35 uppercase tracking-[0.06em] w-fit truncate leading-[1.5] shadow-[0_1px_2px_rgba(224,90,43,0.15)]">
                  <span className="relative flex h-1.5 w-1.5 shrink-0">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-[#e05a2b] opacity-70 animate-ping" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#e05a2b]" />
                  </span>
                  {planLabel}
                </span>
              )}
            </>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-2.5 py-3 flex flex-col gap-0.5 overflow-y-auto">
        {isAdmin ? (
          <>
            <NavSectionLabel label="Overview" first />
            {item('admin-overview', 'dashboard', 'Dashboard')}
            <NavSectionLabel label="People" />
            {item('admin-users', 'adminUsers', 'Users')}
            {item('admin-businesses', 'adminBiz', 'Businesses')}
            <NavSectionLabel label="Monitoring" />
            {item('admin-metrics', 'adminQueue', 'Nudge Queue')}
            {item('admin-ai-health', 'adminAi', 'AI Health')}
            <NavSectionLabel label="Configuration" />
            {item('admin-slots', 'adminSlots', 'Scheduler Slots')}
            <NavSectionLabel label="Billing" />
            {item('admin-billing', 'adminBilling', 'Subscriptions')}
          </>
        ) : (
          <>
            <NavSectionLabel label="Main" first />
            {item('dashboard', 'dashboard', 'Dashboard')}
            {item('contacts', 'contacts', 'Contacts',
              typeof contactsCount === 'number' && contactsCount > 0 ? grayCount(contactsCount) : undefined
            )}
            {item('lapsed', 'lapsed', 'Lapsed',
              typeof lapsedCount === 'number' && lapsedCount > 0 ? redBadge(lapsedCount) : undefined
            )}
            {item('engaging', 'engaging', 'Engaging',
              typeof engagingCount === 'number' && engagingCount > 0 ? tealBadge(engagingCount) : undefined
            )}
            {item('recovered', 'recovered', 'Recovered',
              typeof recoveredCount === 'number' && recoveredCount > 0 ? tealBadge(recoveredCount) : undefined
            )}
            {item('messages', 'messages', 'Messages',
              messagesNotifCount != null && messagesNotifCount > 0 ? tealBadge(messagesNotifCount) : undefined
            )}
            {item('services', 'offerings', 'Offerings')}
            <NavSectionLabel label="Analytics" />
            {item('reports', 'reports', 'Reports')}
            {item('business', 'business', 'Business')}
            {item('settings', 'settings', 'Settings')}
          </>
        )}
      </nav>

      {/* User row + account menu */}
      <div className="px-2.5 py-3 relative border-t border-white/[0.08]" ref={menuRef}>
        {menuOpen && (
          <div className="absolute bottom-[calc(100%+8px)] left-2 right-2 rounded-xl overflow-hidden z-[100] bg-neutral-900 border border-white/10 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
            <button
              type="button"
              className="flex items-center gap-2.5 w-full px-3.5 py-2.5 text-[13px] text-left text-gray-100 bg-transparent hover:bg-white/[0.05] transition-colors cursor-pointer border-none"
              onClick={() => { setMenuOpen(false); onSelectPage('profile') }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              View Profile
            </button>
            <div className="h-px bg-white/10 mx-2.5" />
            <button
              type="button"
              className="flex items-center gap-2.5 w-full px-3.5 py-2.5 text-[13px] text-left text-red-400 bg-transparent hover:bg-red-500/10 transition-colors cursor-pointer border-none"
              onClick={() => { setMenuOpen(false); onSignOut() }}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Sign out
            </button>
          </div>
        )}

        <div
          className="flex items-center gap-2.5 px-2.5 py-2 rounded-[10px] cursor-pointer transition-colors hover:bg-white/[0.04]"
          onClick={() => setMenuOpen(o => !o)}
          title="Account menu"
        >
          {avatarUrl ? (
            <div
              className="w-7 h-7 rounded-full shrink-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${avatarUrl})` }}
              aria-label={displayName ?? 'Account'}
            />
          ) : initials ? (
            <div className="w-7 h-7 rounded-full shrink-0 bg-white/15 flex items-center justify-center text-[11px] font-semibold text-gray-100 select-none">
              {initials}
            </div>
          ) : (
            <div className="w-7 h-7 rounded-full shrink-0 bg-white/10 animate-pulse" />
          )}
          <div className="flex-1 min-w-0">
            {displayName ? (
              <div className="text-[13px] font-semibold text-gray-100 truncate leading-tight">{displayName}</div>
            ) : (
              <div className="h-3 w-24 bg-white/10 rounded animate-pulse" />
            )}
            {email ? (
              <div className="text-[11px] text-white/45 truncate leading-tight mt-0.5">{email}</div>
            ) : (
              <div className="h-2.5 w-32 bg-white/10 rounded animate-pulse mt-1" />
            )}
          </div>
        </div>
      </div>
    </aside>
  )
}
